import { defined } from '@mntn-dev/utilities'
import type { AnyRoute } from '../route.ts'
import { type FindRouteAncestryOptions, findRoute } from './find.ts'

export const findRouteAncestry = (
  route: AnyRoute | undefined,
  { includeSelf, depth = 0 }: FindRouteAncestryOptions = {}
): AnyRoute[] => {
  const routeAncestry = route
    ? defined([
        includeSelf ? route : undefined,
        ...route.segments.map((_, i) =>
          findRoute(
            `/${route.segments.slice(0, route.segments.length - 1 - i).join('/')}`
          )
        ),
      ]).reverse()
    : []

  return routeAncestry.slice(Math.min(depth, routeAncestry.length))
}
